/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Knowledge_Docs_DescriptionInputs */

const en_ai_knowledge_docs_description = /** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload docs the AI concierge can reference when answering buyer questions`)
};

const id_ai_knowledge_docs_description = /** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah dokumen yang dapat dirujuk oleh pramutamu AI saat menjawab pertanyaan pembeli`)
};

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const es_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const fr_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const de_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const ja_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const zh_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const ar_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const it_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const ru_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const pt_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/** @type {(inputs: Ai_Knowledge_Docs_DescriptionInputs) => LocalizedString} */
const ko_ai_knowledge_docs_description = en_ai_knowledge_docs_description;

/**
* | output |
* | --- |
* | "Upload docs the AI concierge can reference when answering buyer questions" |
*
* @param {Ai_Knowledge_Docs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_knowledge_docs_description = /** @type {((inputs?: Ai_Knowledge_Docs_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Knowledge_Docs_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_knowledge_docs_description(inputs)
	if (locale === "es") return es_ai_knowledge_docs_description(inputs)
	if (locale === "fr") return fr_ai_knowledge_docs_description(inputs)
	if (locale === "de") return de_ai_knowledge_docs_description(inputs)
	if (locale === "ja") return ja_ai_knowledge_docs_description(inputs)
	if (locale === "zh") return zh_ai_knowledge_docs_description(inputs)
	if (locale === "ar") return ar_ai_knowledge_docs_description(inputs)
	if (locale === "id") return id_ai_knowledge_docs_description(inputs)
	if (locale === "it") return it_ai_knowledge_docs_description(inputs)
	if (locale === "ru") return ru_ai_knowledge_docs_description(inputs)
	if (locale === "pt") return pt_ai_knowledge_docs_description(inputs)
	return ko_ai_knowledge_docs_description(inputs)
});